import SaasBillingAPI from '../../api/saasBilling';

const state = {
  subscription: null,
  plans: [],
  isFetching: false,
  isProcessingPayment: false,
};

export const getters = {
  getSubscription: $state => $state.subscription,
  getPlans: $state => $state.plans,
  isFetching: $state => $state.isFetching,
  isProcessingPayment: $state => $state.isProcessingPayment,
  isExpired: $state =>
    $state.subscription ? $state.subscription.expired : false,
  daysRemaining: $state =>
    $state.subscription ? $state.subscription.days_remaining : null,
};

export const actions = {
  fetchSubscription: async ({ commit }) => {
    commit('SET_FETCHING', true);
    try {
      const response = await SaasBillingAPI.getSubscription();
      commit('SET_SUBSCRIPTION', response.data.subscription);
      commit('SET_PLANS', response.data.plans);
    } catch (error) {
      // silent
    } finally {
      commit('SET_FETCHING', false);
    }
  },

  createPayment: async ({ commit, dispatch }, payload) => {
    commit('SET_PROCESSING_PAYMENT', true);
    try {
      const response = await SaasBillingAPI.createPayment(payload);
      if (response.data.success) {
        await dispatch('fetchSubscription');
      }
      return response.data;
    } finally {
      commit('SET_PROCESSING_PAYMENT', false);
    }
  },
};

export const mutations = {
  SET_SUBSCRIPTION($state, subscription) {
    $state.subscription = subscription;
  },
  SET_PLANS($state, plans) {
    $state.plans = plans;
  },
  SET_FETCHING($state, value) {
    $state.isFetching = value;
  },
  SET_PROCESSING_PAYMENT($state, value) {
    $state.isProcessingPayment = value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
